
  <div id="page--email-template">
    <form #f="ngForm">

      <div class="content__holder" *ngIf="!previewMode">
        <h2 class="heading">Email Templates</h2>

        <loading-spinner *ngIf="isLoading"></loading-spinner>

        <div class="panel">
          <ul class="grid grid--row-2" *ngIf="emailTemplate && !isLoading">
            <li class="email__item">
              <mat-form-field>
                <mat-select id="emailTypes" name="emailTypes" [(ngModel)]="emailTypeId" (selectionChange)="emailTypeChanged()" placeholder="Email Type">
                  <mat-option *ngFor="let emailType of emailTypes" [value]="emailType.emailTypeId">
                    {{emailType.emailTypeName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </li>
          </ul>
        </div>

        <h2>Details</h2>
        <div class="panel">
          <ul class="grid grid--row-2" *ngIf="emailTemplate && !isLoading">
            <li>
              <mat-form-field>
                <div class="validation__holder">
                  <input matInput type="text" name="from" id="from" placeholder="From address" [(ngModel)]="emailTemplate.from" pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$" required />
                  <div class="validation"></div>
                </div>
              </mat-form-field>
            </li>
            <li>
              <mat-form-field>
                <div class="validation__holder">
                  <input matInput type="text" name="subject" id="subject" placeholder="Subject" [(ngModel)]="emailTemplate.subject" required />
                  <div class="validation"></div>
                </div>
              </mat-form-field>
            </li>
          </ul>
          <ul class="grid grid--row-2">
            <li>
              <div class="email__item-holder">
                <mat-form-field>
                  <input matInput type="text" id="logoUrl" name="logoUrl" [(ngModel)]="emailTemplate.urlToLogo" placeholder="URL for logo" />
                </mat-form-field>
                <label class="email__label"><em>(Please choose a file 100KB or smaller in size)</em></label>
              </div>
            </li>
            <li>
              <img class="email__image-preview" src="{{emailTemplate.urlToLogo}}" *ngIf="emailTemplate.urlToLogo" />
              <img class="email__image-preview" src="./assets/images/striped-background 3.jpg" *ngIf="!emailTemplate.urlToLogo" />
            </li>
          </ul>
        </div>

        <h2>Body</h2>
        <div class="panel">
          <ul class="grid grid--row-1" *ngIf="emailTemplate && !isLoading">
            <li class="email__item">
              <mat-form-field>
                <div class="validation__holder">
                  <input matInput type="text" name="salutation" id="salutation" placeholder="Salutation" [(ngModel)]="emailTemplate.salutation" required />
                  <div class="validation"></div>
                </div>
              </mat-form-field>
            </li>
            <li class="email__item">
              <mat-form-field>
                <div class="validation__holder">
                  <textarea matInput type="text" name="content" id="content" placeholder="Email Body" [(ngModel)]="emailTemplate.content" required></textarea>
                  <div class="validation"></div>
                </div>
              </mat-form-field>
            </li>
            <li class="email__item">
              <mat-form-field>
                <div class="validation__holder">
                  <input matInput type="text" name="closing" id="closing" placeholder="Complimentary closing" [(ngModel)]="emailTemplate.complementaryClosing" required />
                  <div class="validation"></div>
                </div>
              </mat-form-field>
            </li>
            <li class="email__item">
              <mat-form-field>
                <div class="validation__holder">
                  <input matInput type="text" name="name" id="name" placeholder="Name" [(ngModel)]="emailTemplate.name" required />
                  <div class="validation"></div>
                </div>
              </mat-form-field>
            </li>
            <li class="email__item">
              <mat-form-field>
                <div class="validation__holder">
                  <textarea matInput type="text" name="footer" id="footer" placeholder="Footer" [(ngModel)]="emailTemplate.footer" required></textarea>
                  <div class="validation"></div>
                </div>
              </mat-form-field>
            </li>
          </ul>
        </div>

        <div class="button__row">
          <button class="button--box blue preview" (click)="preview()" [disabled]="isSaveDisabled()">Preview</button>
          <button class="button--box blue save" (click)="save()" [disabled]="isSaveDisabled()">Save</button>
        </div>
      </div>


      <!-- PREVIEW MODE -->
      <div class="content__holder email-preview" *ngIf="previewMode">
        <h2 class="list-options__heading heading">Email - {{emailTypeName}} (Preview)</h2>

        <div class="content__holder panel">
          <ul class="email-preview__list">
            <li class="email-preview__item">
              <label class="email-preview__label">From: </label>
              <div class="email-preview__holder">
                <p>{{emailTemplate.from}}</p>
              </div>
            </li>
            <li class="email-preview__item">
              <label class="email-preview__label">Subject: </label>
              <div class="email-preview__holder">
                <p>{{emailTemplate.subject}}</p>
              </div>
            </li>
          </ul>
        </div>

        <div class="content__holder panel">
          <ul class="email-preview__list">
            <li class="email-preview__item" *ngIf="emailTemplate.urlToLogo">
              <img src="{{emailTemplate.urlToLogo}}" style="height:100px; width:auto" />
            </li>

            <li class="email-preview__item">
              <p>{{emailTemplate.salutation}}</p>
            </li>
            <li class="email-preview__item">
              <p>{{emailTemplate.content}}</p>
            </li>
            <li class="email-preview__item">
              <p>{{emailTemplate.complementaryClosing}}</p>
            </li>
            <li class="email-preview__item">
              <p>{{emailTemplate.name}}</p>
            </li>
            <li class="email-preview__item">
              <p class="small">{{emailTemplate.footer}}</p>
            </li>
          </ul>
        </div>

        <div class="button__row">
          <button class="button--box blue back" (click)="back()">Back</button>
        </div>
      </div>
        <!-- PREVIEW MODE -->
    </form>
</div>
